import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  MiddlewareBaseResponse,
  RedeemVoucherCommand,
  Voucher,
  VoucherApi,
  VoucherListFilters,
} from '@ireckonu/shared-ui';

import { APP_ENV } from '../app-config';

@Injectable({ providedIn: 'root' })
export class VoucherService implements VoucherApi {
  private readonly http = inject(HttpClient);
  private readonly configApiBaseUrl = inject(APP_ENV).configApiBaseUrl;

  private get loyaltyProfilesUrl(): string {
    return this.configApiBaseUrl + '/proxy/loyalty/api/v1/loyalty-profiles';
  }

  getVouchers(
    loyaltyProfileId: number,
    filters: VoucherListFilters = {},
  ): Observable<Voucher[]> {
    let params = new HttpParams().set(
      'LoyaltyProfileId',
      loyaltyProfileId.toString(),
    );
    if (filters.Status !== undefined) {
      params = params.set('Status', filters.Status);
    }
    if (filters.Code !== undefined) {
      params = params.set('Code', filters.Code);
    }
    if (filters.VoucherId !== undefined) {
      params = params.set('VoucherId', filters.VoucherId.toString());
    }

    return this.http
      .get<
        MiddlewareBaseResponse<Voucher[]>
      >(`${this.loyaltyProfilesUrl}/${loyaltyProfileId}/vouchers`, { params })
      .pipe(map((response) => response.Data ?? []));
  }

  redeemVoucher(
    loyaltyProfileId: number,
    voucherId: number,
    command: RedeemVoucherCommand,
  ): Observable<Voucher> {
    return this.http
      .post<MiddlewareBaseResponse<Voucher>>(
        `${this.loyaltyProfilesUrl}/${loyaltyProfileId}/vouchers/${voucherId}/redeem`,
        {
          ...command,
          LoyaltyProfileId: loyaltyProfileId,
          VoucherId: voucherId,
        },
      )
      .pipe(map((response) => response.Data));
  }

  revokeVoucher(
    loyaltyProfileId: number,
    voucherId: number,
  ): Observable<Voucher> {
    return this.http
      .post<
        MiddlewareBaseResponse<Voucher>
      >(`${this.loyaltyProfilesUrl}/${loyaltyProfileId}/vouchers/${voucherId}/revoke`, {})
      .pipe(map((response) => response.Data));
  }

  reactivateVoucher(
    loyaltyProfileId: number,
    voucherId: number,
  ): Observable<Voucher> {
    return this.http
      .post<
        MiddlewareBaseResponse<Voucher>
      >(`${this.loyaltyProfilesUrl}/${loyaltyProfileId}/vouchers/${voucherId}/reactivate`, { LoyaltyProfileId: loyaltyProfileId, VoucherId: voucherId })
      .pipe(map((response) => response.Data));
  }
}
